import { addDays, dayFromParts, dayOfDateOnly, daysBetweenDays, type Day } from './calendar';
import { businessZone } from './zone';
import { zonedMidnight, zonedParts } from './zoned';

// Día de negocio (Costa Rica) de un instante, "hoy" y los cortes de un día como
// instantes ISO para los filtros. De 18:00 a 23:59 locales el día UTC ya es el
// siguiente; con la zona del navegador, un usuario en otra zona vería otro día.

function toInstant(value: string | Date): Date {
  return value instanceof Date ? value : new Date(value);
}

/** Día de negocio de un instante (ISO o Date); null si es inválido. */
export function businessDayOf(value: string | Date): Day | null {
  const p = zonedParts(toInstant(value), businessZone());
  return p === null ? null : dayFromParts(p.y, p.m, p.d);
}

/** Hoy en la zona de negocio. */
export function businessToday(now: Date = new Date()): Day {
  return businessDayOf(now) ?? '';
}

function dayStart(day: Day): Date {
  const [y, m, d] = day.split('-').map(Number);
  return zonedMidnight(y ?? 0, m ?? 1, d ?? 1, businessZone());
}

/** Medianoche (00:00) del día en la zona de negocio, en ISO UTC. */
export function startOfBusinessDayIso(day: Day): string {
  return dayStart(day).toISOString();
}

/** Último instante (23:59:59.999) del día en la zona de negocio, en ISO UTC. */
export function endOfBusinessDayIso(day: Day): string {
  return new Date(dayStart(addDays(day, 1)).getTime() - 1).toISOString();
}

/** Días de negocio entre hoy y una fecha pura; null si la fecha es inválida. */
export function daysUntil(dateOnly: string, now: Date = new Date()): number | null {
  const due = dayOfDateOnly(dateOnly);
  return due === null ? null : daysBetweenDays(businessToday(now), due);
}
